export default "__VITE_ASSET__Mm66pp$l__"